import { EShippinggroupStatus } from "enums/shippinggroupEmun"
import { IconBoxUnpacking, IconCheck, IconClock, IconPackage, IconSquareClose, IconTruck, IconTruckDelivery } from "theme/common/Icon.styled"
import { ILoginInformation } from "interfaces/IUser"
import { IMenu } from "interfaces/IMenu"

export const getSummaryMenuOrderSellerSTT = ({
  shippingTypeOption,
  user,
  getSources,
  getChannels,
  sg
}: {
  shippingTypeOption: string[],
  user: ILoginInformation | null,
  getSources: () => string[],
  getChannels: () => string[],
  sg: {
    get_shippingtype_list: () => string[]
  }
}): IMenu[] => {

  const sources = getSources()
  const channels = getChannels()
  const shippingType = shippingTypeOption && shippingTypeOption.length > 0 ? [shippingTypeOption] : sg.get_shippingtype_list()

  const get_user_segments = () => {
    let segments = user?.groups
    return segments?.filter((segment: any) => segment.type === "Segment").map((segment: any) => `*.${segment.id}`)
  }

  const segments = get_user_segments()

  return [
    {
      title: "Bandeja de preparación",
      path: "/order/confirmation",
      icon: <IconCheck />,
      status: EShippinggroupStatus.confirmation,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["AWAITING_STORE_CONFIRMATION"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Packing e impresión de documentos",
      path: "/order/package",
      icon: <IconPackage />,
      status: EShippinggroupStatus.package,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["PENDING_PACKAGE"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Listo para despacho",
      path: "/order/delivery",
      icon: <IconTruckDelivery />,
      status: EShippinggroupStatus.delivery,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["AWAITING_DELIVERY"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Bandeja de recepción",
      path: "/order/in_transit_for_reception",
      stateLocation: {
        aliasStatus: EShippinggroupStatus["in_transit_for_reception"],
        parentStatus: EShippinggroupStatus["transit"]
      },
      icon: <IconTruck />,
      status: EShippinggroupStatus.in_transit_for_reception,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType: "SP",
          "currentStatus.tag":["IN_TRANSIT"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "target.source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Despachados",
      path: "/order/transit",
      icon: <IconTruck />,
      status: EShippinggroupStatus.transit,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["IN_TRANSIT"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Listo para retiro",
      path: "/order/pickup",
      icon: <IconClock />,
      status: EShippinggroupStatus.pickup,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["READY_FOR_PICKUP"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Entregado",
      path: "/order/delivered",
      icon: <IconBoxUnpacking />,
      status: EShippinggroupStatus.delivered,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["DELIVERED"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    },
    {
      title: "Retirados",
      path: "/order/closed",
      icon: <IconSquareClose />,
      status: EShippinggroupStatus.closed,
      optionCount: 0,
      body: {
        size: 1,
        from: 0,
        fields:["orderId"],
        filters: {
          shippingType,
          "currentStatus.tag":["CLOSED"],
          channel: channels,
          "source.id": user?.allSources ? undefined : sources || [],
          "source.items.sku": segments?.length ? segments : undefined,
        }
      }
    }
  ]
}